import { memo, useEffect, useMemo } from 'react';
import ReactFlow, {
    Controls,
    ReactFlowProvider,
    useReactFlow,
} from 'react-flow-renderer';
import { withNamespaces } from 'react-i18next';

import { buildMockSubcontractorsGraph } from '../../../../../mock/subcontractors';
import SubcontractorNode from './SubcontractorNode';

const nodeTypes = {
    subcontractorNode: SubcontractorNode,
};

const SubcontractorsGraphCanvas = ({
    rootName,
    rootSubtitle,
}) => {
    const reactFlowInstance = useReactFlow();

    const { nodes, edges } = useMemo(() => (
        buildMockSubcontractorsGraph({
            rootName,
            rootSubtitle,
        })
    ), [rootName, rootSubtitle]);

    useEffect(() => {
        if (!reactFlowInstance) {
            return;
        }

        const frame = window.requestAnimationFrame(() => {
            reactFlowInstance.fitView({ padding: 0.2, maxZoom: 1 });
        });

        return () => window.cancelAnimationFrame(frame);
    }, [reactFlowInstance, nodes, edges]);

    return (
        <ReactFlow
            nodes={nodes}
            edges={edges}
            nodeTypes={nodeTypes}
            nodesDraggable={false}
            nodesConnectable={false}
            elementsSelectable={false}
            panOnScroll
            zoomOnScroll={false}
            minZoom={0.4}
            maxZoom={1.2}
            proOptions={{ hideAttribution: true }}
        >
            <Controls showInteractive={false} />
        </ReactFlow>
    );
};

const SubcontractorsGraph = ({
    rootName,
    rootSubtitle,
}) => (
    <div className="carrier-guard-subcontractors-graph">
        <ReactFlowProvider>
            <SubcontractorsGraphCanvas
                rootName={rootName}
                rootSubtitle={rootSubtitle}
            />
        </ReactFlowProvider>
    </div>
);

export default withNamespaces()(memo(SubcontractorsGraph));
